export default __webpack_public_path__ + "static/media/bbank-eth.086cf1cd.png";